<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  })
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;700&display=swap");

* {
  font-family: Ubuntu;
}

body {
  font-size: 14px;
}

h1 {
  font-size: 2.14em;
  font-weight: bold;
}

h2 {
  font-size: 1.42em;
  font-weight: bold;
}

.all-height {
  height: 100vh;
}
</style>
